import {
  ClientOrganizationAdmin,
  ClientOrganizationInput,
} from '../../application/entities/client-organization-admin.entity';
import {
  ClientOrganizationDto,
  ClientOrganizationListResponseDto,
  ClientOrganizationRequestDto,
  ClientOrganizationResponseDto,
} from '../dto/client-organization.dto';

export function toClientOrganizationAdmin(dto: ClientOrganizationDto): ClientOrganizationAdmin {
  return {
    uuid: dto.uuid,
    name: dto.name,
    listingNumber: dto.listingNumber,
    logoUrl: dto.logoUrl ?? null,
    primaryColor: dto.primaryColor ?? null,
    secondaryColor: dto.secondaryColor ?? null,
    updatedAt: dto.updatedAt ?? null,
  };
}

export function toClientOrganizationAdminFromResponse(
  response: ClientOrganizationResponseDto,
): ClientOrganizationAdmin {
  return toClientOrganizationAdmin(response.data);
}

export function toClientOrganizationAdminList(
  response: ClientOrganizationListResponseDto,
): ClientOrganizationAdmin[] {
  return (response.data?.organizations ?? []).map(toClientOrganizationAdmin);
}

export function toClientOrganizationRequestDto(
  input: ClientOrganizationInput,
): ClientOrganizationRequestDto {
  return {
    name: input.name.trim(),
    listingNumber: input.listingNumber.trim(),
    primaryColor: input.primaryColor || null,
    secondaryColor: input.secondaryColor || null,
  };
}
